module.exports = __webpack_public_path__ + "static/media/product_main.20f222cd.jpg";